import {
  MDBBtn,
  MDBDatatable,
  MDBDateTimepicker,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRadio,
  MDBSelect,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../views/popups/PopupLoader";
import AddOverride from "../../views/popups/callflow/AddOverride";
import ScheduleWeekDay from "./weekday";
import { getMisc, getSpecifSchedulesForCallFlow } from "../../apiclients/streamsapi_bridge";
import AddHolidays from "../../views/popups/callflow/AddHolidays";
import { useNavigate } from "react-router";
function WeelySchedulePopup(props) {
  const [timezone, settimezone] = useState([]);
  const [tzvalue, setTZValue] = useState(0);
  const navigate = useNavigate();
  const [scheduleId, setScheduleId] = useState(
    props.data && props.data.selected_object
      ? props.data.selected_object.schedule_id
      : null
  );
  const [isloading, setIsloading] = useState(false);

  async function fetchSchedule() {
    try {
      sessionStorage.setItem("current_link", "huntgroup");
      setIsloading(true);
      const response = await getSpecifSchedulesForCallFlow(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        scheduleId
      );
      const rawData = await response.json();
      console.log(rawData);
    } catch (e) {
    } finally {
      setIsloading(false);
    }
  }

  useEffect(() => {
    if (scheduleId) {
      fetchSchedule();
    }
  }, [scheduleId]);

  const hNameRef = useRef();
  const [error, setError] = useState(null);
  const [toTimerror, setToTimerror] = useState(null);
  const [fromTimerror, setFromTimerror] = useState(null);
  const [allDays, setAllDays] = useState([
    {
      day: "Sunday",
      value: 1,
      fromtime: "08:00 AM",
      totime: "05:00 PM",
      tfenabled: false,
      enabled: false,
    },
    {
      day: "Monday",
      value: 2,
      fromtime: "08:00 AM",
      totime: "05:00 PM",
      tfenabled: false,
      enabled: true,
    },
    {
      day: "Tuesday",
      value: 3,
      fromtime: "08:00 AM",
      totime: "05:00 PM",
      tfenabled: false,
      enabled: true,
    },
    {
      day: "Wednesday",
      value: 4,
      fromtime: "08:00 AM",
      totime: "05:00 PM",
      tfenabled: false,
      enabled: true,
    },
    {
      day: "Thursday",
      value: 5,
      fromtime: "08:00 AM",
      totime: "05:00 PM",
      tfenabled: false,
      enabled: true,
    },
    {
      day: "Friday",
      value: 6,
      fromtime: "08:00 AM",
      totime: "05:00 PM",
      tfenabled: false,
      enabled: true,
    },
    {
      day: "Saturday",
      value: 7,
      fromtime: "08:00 AM",
      totime: "05:00 PM",
      tfenabled: false,
      enabled: false,
    },
  ]);
  const [overrideName, setOverrideName] = useState(null);
  const [overrideDay, setOverrideDay] = useState(null);
  const [overrideFrom, setOverrideFrom] = useState(null);
  const [overrideTo, setOverrideTo] = useState(null);
  const [addHolidayName, setAddHolidayName] = useState(null);
  const [addHolidayFrom, setAddHolidayFrom] = useState(null);
  const [addHolidayFromTime, setAddHolidayFromTime] = useState(null);
  const [addHolidayTo, setAddHolidayTo] = useState(null);
  const [addHolidayToTime, setAddHolidayToTime] = useState(null);
  const [weekOption, setWeekOption] = useState("fulltime");
  const [overRideData, setOverRideData] = useState([]);
  const [addHolidaData, setAddHolidaData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [addOverride, setAddOverride] = useState(false);
  const addOverrideRef = useRef();
  const [addOverrideError, setAddOverrideError] = useState(false);
  const addHolidayRef = useRef();
  const [addHolidayError, setAddHolidayError] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorFlags, setErrorFlags] = useState({
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
  });
  const toggleAddOverrride = () => {
    setAddOverride(!addOverride);
    setTimeout(() => {
      if (hNameRef && hNameRef.current) {
        hNameRef.current.focus();
      }
    }, 500);
  };
  const toggleAddHolidays = () => {
    setAddHoliday(!addHoliday);
    setTimeout(() => {
      if (hNameRef && hNameRef.current) {
        hNameRef.current.focus();
      }
    }, 500);
  };
  const holidayChange = (e) => {
    const value = e.target.value;
    setAddHolidayName(value);

    if (!value.trim()) {
      setError({ name: { message: "Please enter Name" } });
      if (hNameRef) {
        hNameRef.current.focus();
      }
    } else {
      setError({ name: {} }); // Clear the error
    }
  };
  function totimeChange(value) {
    if (!value.trim()) {
      setToTimerror({ addHolidayTo: { message: "Please enter To date" } });
    } else {
      setAddHolidayTo(value.split(",")[0].trim());
      setAddHolidayToTime(value.split(",")[1].trim());
      setToTimerror({ addHolidayTo: { message: "" } }); // Clear the error
    }
  }
  function formtimeChange(value) {
    if (!value.trim()) {
      setFromTimerror({ addHolidayFrom: { message: "Please enter From date" } })
    } else {
      setAddHolidayFrom(value.split(",")[0]?.trim());
      setAddHolidayFromTime(value.split(",")[1]?.trim());
      setFromTimerror({ addHolidayFrom: { message: "" } }); // Clear the error
    }

  }
  const [addHoliday, setAddHoliday] = useState(false);
  const toggleAddHoliday = () => {
    setAddHolidayName("");
    setAddHolidayFrom(null);
    setAddHolidayFromTime(null);
    setAddHolidayTo(null);
    setAddHolidayToTime(null);
    setAddHoliday(!addHoliday);
  };
  const actionData2 = {
    columns: [
      { label: "Name", field: "name" },
      { label: "Day", field: "dayname" },
      { label: "From", field: "from" },
      { label: "To", field: "to" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: (() => {
      let lastSeenName = "";
      const sorted = [...overRideData].sort((a, b) => a.name.localeCompare(b.name));
      return sorted.map((row) => {
        const displayName = row.name === lastSeenName ? "" : row.name;
        lastSeenName = row.name;
        return {
          ...row,
          name: displayName,
          delete: (
            <>
              <MDBIcon
                onClick={(e) => deleteOverride(e, row)}
                fas
                style={{ cursor: "pointer" }}
                icon="times"
                color="primary"
              />
            </>
          ),
        };
      });
    })(),
  };
  const actionDataAH = {
    columns: [
      { label: "Name", field: "name" },
      { label: "From", field: "from" },
      { label: "To", field: "to" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: addHolidaData.map((row) => {
      return {
        ...row,
        delete: (
          <>
            <MDBIcon
              onClick={(e) => deleteOverride(e, row)}
              fas
              style={{ cursor: "pointer" }}
              icon="times"
              color="primary"
            />
          </>
        ),
      };
    }),
  };

  const createSchedule = async (e) => {
    let schduleObj = {};
    schduleObj.all_time = weekOption === "fulltime";
    schduleObj.weekly_schedule = {};
    schduleObj.weekly_schedule.sun = {
      selected: allDays[0].enabled,
      from_time: allDays[0].fromtime,
      to_time: allDays[0].totime,
      twenty_four: allDays[0].tfenabled,
    };
    schduleObj.weekly_schedule.mon = {
      selected: allDays[1].enabled,
      from_time: allDays[1].fromtime,
      to_time: allDays[1].totime,
      twenty_four: allDays[1].tfenabled,
    };
    schduleObj.weekly_schedule.tue = {
      selected: allDays[2].enabled,
      from_time: allDays[2].fromtime,
      to_time: allDays[2].totime,
      twenty_four: allDays[2].tfenabled,
    };
    schduleObj.weekly_schedule.wed = {
      selected: allDays[3].enabled,
      from_time: allDays[3].fromtime,
      to_time: allDays[3].totime,
      twenty_four: allDays[3].tfenabled,
    };
    schduleObj.weekly_schedule.thu = {
      selected: allDays[4].enabled,
      from_time: allDays[4].fromtime,
      to_time: allDays[4].totime,
      twenty_four: allDays[4].tfenabled,
    };
    schduleObj.weekly_schedule.fri = {
      selected: allDays[5].enabled,
      from_time: allDays[5].fromtime,
      to_time: allDays[5].totime,
      twenty_four: allDays[5].tfenabled,
    };
    schduleObj.weekly_schedule.sat = {
      selected: allDays[6].enabled,
      from_time: allDays[6].fromtime,
      to_time: allDays[6].totime,
      twenty_four: allDays[6].tfenabled,
    };
    schduleObj.overrides = { add_overrides: [] };
    schduleObj.holidays = { add_holidays: [] };
    overRideData.map((override) => {
      schduleObj.overrides.add_overrides = [
        ...schduleObj.overrides.add_overrides,
        {
          from_time: override.from,
          to_time: override.to,
          twenty_four: override.tfenabled,
          name: override.name,
          day: override.day,
        },
      ];
    });
    addHolidaData.map((holiday) => {
      schduleObj.holidays.add_holidays = [
        ...schduleObj.holidays.add_holidays,
        { from: holiday.from, to: holiday.to, name: holiday.name },
      ];
    });
    schduleObj.timezone = tzvalue;
    // Removing the disabled weekly_schedules additional parametere , which are not required..
    for (const weekDay in schduleObj.weekly_schedule) {
      if (schduleObj.weekly_schedule[weekDay].selected === false) {
        schduleObj.weekly_schedule[weekDay] = {
          selected: false,
        };
      }
    }
    console.log(
      `length checking:: ${schduleObj.overrides.add_overrides?.length ?? 0}`
    );
    if ((schduleObj.overrides.add_overrides?.length ?? 0) == 0) {
      delete schduleObj.overrides.add_overrides;
      delete schduleObj.overrides;
    }
    if ((schduleObj.holidays.add_holidays?.length ?? 0) == 0) {
      delete schduleObj.holidays.add_holidays;
      delete schduleObj.holidays;
    }

    console.log(`data::${JSON.stringify(schduleObj)}`);
    // let saverep = await createSchedule(schduleObj);
    // let saverepeMsg = await saverep.json();
    // console.log(saverepeMsg);
    // if (saverepeMsg.status && saverepeMsg.status == "success") {
    props.onCreate(schduleObj, props.node);
    // }
    props.onClose();
  };
  const deleteOverride = (e, row) => {
    console.log(row);
    let tod = overRideData.filter((od) => od.id != row.id);
    let tah = addHolidaData.filter((ah) => ah.id != row.id);
    setOverRideData(tod);
    setAddHolidaData(tah);
  };
  const createOverrideSchedule = (entries) => {
    toggleAddOverrride();
    const newRows = (Array.isArray(entries) ? entries : [entries]).map((data) => ({
      id: new Date().getTime() + "_" + data.day,
      name: data.name,
      day: data.day,
      dayname: data.day == "sun" ? "Sunday" : data.day == "mon" ? "Monday" : data.day == "tue" ? "Tuesday"
        : data.day == "wed" ? "Wednesday" : data.day == "thu" ? "Thursday" : data.day == "fri" ? "Friday" : "Saturday",
      from: data.tfenabled ? "12:00 AM" : data.fromTime,
      to: data.tfenabled ? "11:59 PM" : data.toTime,
      tfenabled: data.tfenabled,
      fullday: data.tfenabled + "" == "true" ? "Yes" : "No",
      position: data.tfenabled ? data.day + " Full Day" : data.day + " From " + data.fromTime + " to " + data.toTime,
    }));
    setOverRideData((prev) => [...prev, ...newRows]);
  };
  //   function checkHolidayDates(addHolidayFrom, addHolidayTo) {
  //     // Convert the dates into Date objects
  //     const [monthFrom, dayFrom, yearFrom] = addHolidayFrom.split('/');
  //     const [monthTo, dayTo, yearTo] = addHolidayTo.split('/');

  //     const startDate = new Date(yearFrom, monthFrom - 1, dayFrom); // month is zero-indexed
  //     const endDate = new Date(yearTo, monthTo - 1, dayTo); // month is zero-indexed

  //     // Compare the dates
  //     if (endDate < startDate) {

  //         return false;
  //     }

  //     return true;
  // }

  function createHolidaysSchedule(allrow) {
    toggleAddHolidays();
    setAddHolidaData([...addHolidaData, allrow]);
  }
  // const createHoliday = (e) => {
  //   console.log("addHolidayFrom:::" , addHolidayFrom)
  //   console.log("addHolidayTo:::" , addHolidayTo)
  //   let datecheck = checkHolidayDates(addHolidayFrom , addHolidayTo )
  //   if (!datecheck){
  //     setError({ name: { message: "in this date  date format is not perfect " } })
  //     return;
  //   }
  //   if (!addHolidayName || addHolidayName.trim() == "") {
  //     setError({ name: { message: "Please enter Name" } });
  //     if (hNameRef) {
  //       hNameRef.current.focus();
  //     }
  //     return;
  //   } else if (/[^a-zA-Z0-9]/.test(addHolidayName)) {
  //     setError({ name: { message: "Special characters are not allowed!" } });
  //     return;
  //   } else if (!addHolidayFrom || addHolidayFrom.trim() == "") {
  //     setFromTimerror({ addHolidayFrom: { message: "Please enter From date" } });
  //     return;
  //   } else if (!addHolidayTo || addHolidayTo.trim() == "") {
  //     setToTimerror({ addHolidayTo: { message: "Please enter To date" } });
  //     return;
  //   } else {
  //     setError(null);
  //     setToTimerror(null);
  //     setFromTimerror(null);
  //     toggleAddHoliday();
  //   }

  //   let allrow = {
  //     id: new Date().getTime(),
  //     name: addHolidayName,
  //     from: addHolidayFrom + " " + addHolidayFromTime,
  //     to: addHolidayTo + " " + addHolidayToTime,
  //     position:
  //       "From " +
  //       addHolidayFrom +
  //       " " +
  //       addHolidayFromTime +
  //       " to " +
  //       addHolidayTo +
  //       " " +
  //       addHolidayToTime,
  //   };
  //   console.log(`JOSon.string${JSON.stringify(allrow)}`);
  //   setAddHolidaData([...addHolidaData, allrow]);
  // };
  const changeDay = (e) => { };

  const setOverideTimeValues = (tobject) => {
    console.log(tobject);
    setOverrideDay(tobject.tfenabled);
    setOverrideFrom(tobject.fromTime);
    setOverrideTo(tobject.toTime);
  };
  const onupdate = (tobject) => {
    console.log(tobject);

    let tdayObj = {};
    console.log(tobject.day);
    console.log(allDays);
    let tAllObj = allDays.filter((tday) => tday.day === tobject.day)[0];

    tAllObj.fromtime = tobject.fromTime;
    tAllObj.enabled = tobject.enabled;
    tAllObj.totime = tobject.toTime;
    tAllObj.value = tobject.value;
    tAllObj.tfenabled = tobject.tfenabled;
    let trest = allDays.filter((tday) => tday.day !== tobject.day);

    console.log(tAllObj);
    let tmpdays = [...trest, tAllObj];
    setAllDays(
      tmpdays.sort((a, b) => {
        return a.value - b.value;
      })
    );
    console.log(allDays);
  };
  const onweeklyError = (errorInfo) => {
    const { flag, day } = errorInfo;
    console.log("error state :::", JSON.stringify(errorFlags));
    setErrorFlags((prevFlags) => ({
      ...prevFlags,
      [day.toLowerCase()]: flag,
    }));

    if (flag) {
      console.log(`Error occurred on ${day}`);
    } else {
      console.log(`No error on ${day}`);
    }
  };

  useEffect(() => {
    getCompanyInfoMisc()
    setTZValue(props?.timezone)
    console.log(props?.timezone)
  }, [])

  async function getCompanyInfoMisc() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["global_company_info"],
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("getCompanyInfoMisc for ::::::::::::: " + JSON.stringify(tdata));
    let timezoneOptions = tdata?.misc?.global_company_info?.timezones ?? [];
    settimezone(
      timezoneOptions.map((item) => {
        const [location, offset] = item.time_zone.split("  ");
        return {
          text: location,
          secondaryText: offset,
          value: parseInt(item.tid),
        };
      })
    );

  }



  const selectRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const openUsersPopup = () => {
    setDropdownOpen(true);
  }

  const closeUsersPopup = () => {
    setDropdownOpen(false);
  }

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      console.log("Clicked outside dropdown");
      setDropdownOpen(false);
    }
  };



  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div className="tel-numbers mt-1">
        <strong>{t("weeklyschedule")}</strong>
      </div>
      <div className="d-flex align-items-center justify-content-start mt-2">
        <MDBRadio
          name="inlineRadio"
          id="inlineRadio1"
          value="fulltime"
          label="24/7"
          inline
          checked={weekOption === "fulltime"}
          onChange={() => setWeekOption("fulltime")}
        />
        <MDBRadio
          name="inlineRadio"
          id="inlineRadio2"
          value="weekly"
          label="Weekly Schedule"
          inline
          checked={weekOption === "weekly"}
          onChange={() => setWeekOption("weekly")}
        />


        {(!props.isLuna) &&
          (
            <div class="d-flex align-items-center ps-4">
              <div class="tel-numbers">Timezone</div>
              <div class="d-flex">
                <div className="w-100">
                  <div class="ms-2" ref={selectRef}>
                    <MDBSelect
                      //   style={{ width: "210px" }}
                      search
                      className="timeZone"
                      label={false}
                      open={dropdownOpen}
                      onOpen={() => openUsersPopup()}
                      onClosed={() => closeUsersPopup()}
                      data={timezone}
                      value={tzvalue}
                      onChange={(e) => {
                        if (e && e.value) {
                          const selectedValue = parseInt(e.value);
                          console.log("selectedValue:::", selectedValue)
                          setTZValue(selectedValue);
                          setDropdownOpen(false);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}



      </div>
      {weekOption === "weekly" && (
        <>
          {allDays &&
            allDays.map((dayObj) => (
              <>
                <ScheduleWeekDay
                  day={dayObj.day}
                  value={dayObj.value}
                  tfrom={dayObj.fromtime}
                  tto={dayObj.totime}
                  tfenabled={dayObj.tfenabled}
                  enabled={dayObj.enabled}
                  updateback={onupdate}
                  errorFlag={(errorInfo) => onweeklyError(errorInfo)}
                />
              </>
            ))}
        </>
      )}
      {!(props.isLuna) && (<>
        <div className="add-numbermain">
          <div className="tel-numbers mt-1">
            <strong>{t("weeklyOverrides")}</strong>
          </div>
          <MDBBtn onClick={toggleAddOverrride}>
            <MDBIcon fas icon="plus" className="me-2" />
            {t("addOverride")}
          </MDBBtn>
        </div>

        <div className="weeklyTable">
          <MDBDatatable
            noFoundMessage="No Records"
            hover
            data={actionData2}
            pagination={false}
          />
        </div>

      </>)}
      <div className="add-numbermain">
        <div className="tel-numbers mt-1">
          <strong>{t("Holiday")}</strong>
        </div>
        <MDBBtn onClick={toggleAddHoliday}>
          <MDBIcon fas icon="plus" className="me-2" />
          {t("addHoliday")}
        </MDBBtn>
      </div>
      <div className="weeklyTable">
        <MDBDatatable
          sortField="Name"
          className="actioncolumn"
          hover
          noFoundMessage="No Records"
          data={actionDataAH}
          pagination={false}
        />
      </div>
      <MDBModalFooter>
        <MDBBtn color="secondary" onClick={props.onClose}>
          Close
        </MDBBtn>
        <MDBBtn
          onClick={(e) => createSchedule(e)}
          disabled={Object.values(errorFlags).includes(true)}
        >
          Create
        </MDBBtn>
      </MDBModalFooter>

      {addOverride && (
        <PopupLoader
          size="lg"
          title={t("addOverride")}
          content={
            <AddOverride
              ref={addOverrideRef}
              onClose={toggleAddOverrride}
              onSuccess={createOverrideSchedule}
              overRideData={overRideData}
              onValidationChange={(hasError) => setAddOverrideError(hasError)}
            />
          }
          footer={
            <>
              <MDBBtn color="secondary" onClick={toggleAddOverrride}>
                {t("close")}
              </MDBBtn>
              <MDBBtn
                disabled={addOverrideError}
                onClick={() => {
                  if (addOverrideRef.current) {
                    addOverrideRef.current.onsubmit();
                  }
                }}
              >
                {t("add")}
              </MDBBtn>
            </>
          }
          onShow={setAddOverride}
          onClose={toggleAddOverrride}
        />
      )}
      {addHoliday && (
        <PopupLoader
          title={t("addHoliday")}
          content={
            <AddHolidays
              ref={addHolidayRef}
              onClose={toggleAddHolidays}
              onSuccess={createHolidaysSchedule}
              open={addHoliday}
              holidays={addHolidaData}
              onValidationChange={(hasError) => setAddHolidayError(hasError)}
            />
          }
          footer={
            <>
              <MDBBtn color="secondary" onClick={toggleAddHolidays}>
                {t("close")}
              </MDBBtn>
              <MDBBtn
                disabled={addHolidayError}
                onClick={() => {
                  if (addHolidayRef.current) {
                    addHolidayRef.current.createHoliday();
                  }
                }}
              >
                {t("add")}
              </MDBBtn>
            </>
          }
          onShow={setAddHoliday}
          onClose={toggleAddHolidays}
        />
      )}

      {/* <MDBModal open={addHoliday} setShow={setAddHoliday}>
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{t("addHoliday")}</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleAddHoliday}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="tel-numbers">
                <strong>{t("name")}</strong>
              </div>
              <div className="form pt-1 w-100">
                <input
                  type="text"
                  ref={hNameRef}
                  className="form-control w-100 form-outline"
                  onChange={(e) => holidayChange(e)}
                  value={addHolidayName}
                  maxLength={15}
                />
                {error && error.name && (
                  <p className="text-danger">{error.name.message}</p>
                )}
              </div>

              <div className="d-flex justify-content-between">
                <div className="tel-numbers mt-2 w-50">
                  <strong>{t("from")}</strong>
                  <div className="form pt-1 w-100">
                    <MDBDateTimepicker
                    inline
                      dateFormat="mm/dd/yyyy"
                      timeformat="hh:mm A"
                      defaultDate={addHolidayFrom}
                      defaultTime={addHolidayFromTime}
                      inputToggle
                      value={
                        !addHolidayFrom
                          ? ""
                          : addHolidayFrom + "," + addHolidayFromTime
                      }
                      onChange={(value) => {
                        formtimeChange(value)
                      }}
                    />
                    {fromTimerror && fromTimerror.addHolidayFrom && (
                      <p className="text-danger">
                        {fromTimerror.addHolidayFrom.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="tel-numbers mt-2 w-50">
                  <strong className="ms-2">{t("to")}</strong>
                  <div className="form pt-1 w-100 ps-2">
                    <MDBDateTimepicker
                    inline
                      dateFormat="mm/dd/yyyy"
                      timeformat="hh:mm A"
                      defaultDate={addHolidayTo}
                      defaultTime={addHolidayToTime}
                      inputToggle
                      value={
                        !addHolidayTo
                          ? ""
                          : addHolidayTo + "," + addHolidayToTime
                      }
                      onChange={(value) => {
                        totimeChange(value)
                      }}
                    />
                    {toTimerror && toTimerror.addHolidayTo && (
                      <p className="text-danger">
                        {toTimerror.addHolidayTo.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter className="mb-3 me-3">
              <MDBBtn color="secondary" onClick={toggleAddHoliday}>
                Close
              </MDBBtn>
              <MDBBtn onClick={(e) => createHoliday(e)}>Add</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal> */}
    </>
  );
}
export default WeelySchedulePopup;
